import { createApp } from '@app/adapters/create-app'

import PinnedReports from '@app/application/report/components/pinned-reports.vue'

window.onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='reports/pinned-reports']").each(function () {
    createApp(PinnedReports, {
      expectedCount: Number(this.dataset.pinnedCount),
    }).mount(this)
  })
})
